import { ReactNode } from 'react';

interface CompanyWithRole {
  id: string;
  role?: string;
}

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles: string[];
  isSuperadmin?: boolean;
  fallback?: ReactNode;
  companies?: CompanyWithRole[];
  currentCompanyId?: string;
}

/**
 * RoleGuard component
 * Controls visibility of elements based on user role
 * Superadmin has access to everything
 */
export function RoleGuard({
  children,
  allowedRoles,
  isSuperadmin,
  fallback = null,
  companies = [],
  currentCompanyId,
}: RoleGuardProps) {
  // Superadmin has access to everything
  if (isSuperadmin) {
    return <>{children}</>;
  }

  // Find user's role in current company
  const currentMembership = companies.find(
    (c) => c.id === currentCompanyId
  );
  const userRole = currentMembership?.role;

  if (!userRole || !allowedRoles.includes(userRole)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
